import { createUseTenant } from "@freyr/freyr-react-common-components";
import { getCachedBranding } from "../common/branding";

export const useTenant = createUseTenant(getCachedBranding);
